const cartSection = document.querySelector('.cart-section');
let currentCodes = [];

class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.discountInput = this.querySelector('#cartDiscount');
    this.applyButton = this.querySelector('#applyDiscount');
    this.currentCodesContainer = this.querySelector('.cart-discount__current');
    
    this.setupEventListeners();
    this.getCart();
  }

  // set up event listeners
  setupEventListeners() {
    this.discountInput.addEventListener('input', this.toggleButton.bind(this));

    this.applyButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.updateDiscount(this.discountInput.value, 'add');
    });

    document.addEventListener('quantityUpdated', () => {
      this.getCart();
    })
  }

  // get cart JSON to get all applicable discount codes
  getCart() {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((response) => this.updateCurrentCodes(response, true))
    .finally(() => {
      this.removeButtonsListeners();
      this.checkApplicableDiscounts();
    })
  }

  // once current promocodes have been updated in DOM, set up all remove button eventListeners
  removeButtonsListeners() {
    document.querySelectorAll('current-discount-code button').forEach((button) => {
      button.addEventListener('click', (e) => {
        this.updateDiscount(e.target.closest('button').dataset.code, 'remove');
      })
    })
  }

  // enable/disable validation button whether input is filled or not
  toggleButton() {
    if (this.discountInput.value == '' || this.discountInput.value == null) {
      this.applyButton.setAttribute('disabled', 'disabled');
    } else {
      this.applyButton.removeAttribute('disabled');
    }
  }

  // add or remove promocode
  updateDiscount(code, action) {
    if (action == 'add') {
      currentCodes.push(code);
    } else {
      const index = currentCodes.indexOf(code);
      if (index > -1) currentCodes.splice(index, 1);
    }

    this.postDiscount(currentCodes, code, action);
  }

  // POST cart update with new promocodes array
  postDiscount(codes, updatedCode, action) {
    let discountCodes = codes.join(','),
        success = false;

    cartSection.classList.add('loading');

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: discountCodes })
    })
    .then(response => response.json())
    .then((response) => this.updateCurrentCodes(response, false))
    .then(() => {
      if (action == 'add') {
        success = currentCodes.includes(updatedCode) ? true : false;
      } else {
        success = currentCodes.includes(updatedCode) ? false : true;
      }
    })
    .catch((error) => console.error('Error:', error))
    .finally(() => this.udpateCart(updatedCode, action, success))
  }

  // once cart JSON is updated, get current codes
  updateCurrentCodes(response, updateDom) {
    currentCodes = [];
    if (updateDom) this.currentCodesContainer.innerHTML = '';
    if (response.discount_codes.length > 0) {
      for (const codeItem of response.discount_codes) {
        if (codeItem.code != '' && codeItem.applicable) {
          currentCodes.push(codeItem.code);

          if (updateDom) {
            const codeContent = document.createElement('current-discount-code'),
                  currentCodeItem = currentDiscountCode(codeItem.code);

            codeContent.innerHTML = currentCodeItem;
            this.currentCodesContainer.appendChild(codeContent);
          }
        }
      }
    }
  }

  // udpate cart HTML to display promocodes changes
  udpateCart(updatedCode, action, success) {
    fetch('/cart?section=cart')
      .then((response) => response.text())
      .then((response) => {
        const itemsHtml = new DOMParser().parseFromString(response, 'text/html').querySelector('.cart-items'),
              summaryHtml = new DOMParser().parseFromString(response, 'text/html').querySelector('.cart-summary');

        document.querySelector('.cart-items').innerHTML = itemsHtml.innerHTML;
        document.querySelector('.cart-summary').innerHTML = summaryHtml.innerHTML;
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        cartSection.classList.remove('loading');
        if (success == false) {
          document.querySelector('.cart-discount__error').innerHTML = discountError(updatedCode, action);
          setTimeout(() => {
            document.querySelector('.cart-discount__error').innerHTML = '';
          }, 3000);
        }
      })
  }

  // check if tooltip should be displayed to promote applicable discounts
  checkApplicableDiscounts() {
    if (this.querySelector('.cart-discount__tooltip') != null) {
      const applicableDiscounts = this.querySelectorAll('.applicable-discount');

      applicableDiscounts.forEach((discount) => {
        if (!currentCodes.includes(discount.getAttribute('code'))) {
          discount.classList.add('revealed');
          discount.querySelector('button').addEventListener('click', () => {
            this.updateDiscount(discount.getAttribute('code'), 'add');
          });
        }
      })
    }
  }
}

customElements.define('cart-discount', CartDiscount);
